import { Card, CardContent, Icon, Stack, Typography } from "@mui/material";
import React from "react";
import body from "../../assets/body.png";
import calendar from "../../assets/calendar.png";
import meter from "../../assets/dashboard.png";
import warranty from "../../assets/medal.png";
import doors from "../../assets/door.png";
import color from "../../assets/color.png";
import seat from "../../assets/car-seat.png";
import cylinder from "../../assets/piston.png";
import { shortenString } from "../../utils/shortenString";

const OverviewCard = ({
  objKey,
  objValue,
  elevation,
  cardPadding,
  cardVariant,
  label,
}) => {
  // Get icon images based on the key provided in props
  const getIconImage = (key) => {
    let icon = null;
    if (key === "bodyTypeEn") {
      icon = body;
    } else if (key === "yearOfManufacture") {
      icon = calendar;
    } else if (key === "mileage") {
      icon = meter;
    } else if (key === "warrantyTillDate") {
      icon = warranty;
    } else if (key === "numberOfDoors") {
      icon = doors;
    } else if (key === "color") {
      icon = color;
    } else if (key === "numberOfSeats") {
      icon = seat;
    } else if (key === "cylinderCapacity") {
      icon = cylinder;
    } else {
      icon = null;
    }

    return icon;
  };

  return (
    <Card
      elevation={elevation}
      sx={{ width: "100%", height: "100%" }}
      variant={cardVariant}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: cardPadding,
          height: "100%",
        }}
      >
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          sx={{ height: "100%" }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "12px",
              // textTransform: "uppercase",
              textAlign: "center",
            }}
          >
            {label && label}
          </Typography>
          <Icon sx={{ maxWidth: "32px", minHeight: "32px" }}>
            <img width="100%" src={getIconImage(objKey)} alt={objKey} />
          </Icon>

          {objKey === "warrantyTillDate" ? (
            objValue !== "" ? (
              objValue.toLowerCase() !== "no" ? (
                <Typography
                  variant="caption"
                  sx={{ textTransform: "capitalize", textAlign: "center" }}
                >
                  Yes
                </Typography>
              ) : (
                <Typography
                  variant="caption"
                  sx={{ textTransform: "capitalize", textAlign: "center" }}
                >
                  No
                </Typography>
              )
            ) : (
              <Typography
                variant="caption"
                sx={{ textTransform: "capitalize", textAlign: "center" }}
              >
                No
              </Typography>
            )
          ) : objKey === "mileage" ? (
            <Typography
              variant="caption"
              sx={{
                textTransform: "capitalize",
                textAlign: "center",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {objValue !== null ? objValue.toLocaleString() : "-"}
            </Typography>
          ) : objKey === "cylinderCapacity" ? (
            objValue !== "" ? (
              <Typography
                variant="caption"
                sx={{
                  textTransform: "capitalize",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {objValue}
              </Typography>
            ) : (
              "NA"
            )
          ) : (
            <Typography
              variant="caption"
              sx={{
                textTransform: "capitalize",
                textAlign: "center",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {objValue !== null ? shortenString(objValue, 7) : "-"}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default OverviewCard;
